/*       */

import React from 'react';

import ConnectorLog from 'app/containers/Designer/Pipeline/Components/ConnectorLog';

const panels = settingValues => {
    return [
        {
            type: 'custom',
            properties: {
                cid: 'topicStatusPanel',
                name: 'data',
                pipelineId: settingValues.details.id,
                handleConnectorStatus: settingValues.handleConnectorStatus,
                details: settingValues.details,
                pipelineMonitor: settingValues.pipelineMonitor,
                pipelineStatus: settingValues.pipelineStatus,
                getCurrentConnectorStatus: settingValues.getCurrentConnectorStatus,
                noBackground: true,
                Component: props => <ConnectorLog {...props} />,
            },
        },
    ].filter(Boolean);
};

export default {
    defaults: {},
    panels: settingValues => panels(settingValues),
};
